import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confimation-dialog',
    templateUrl: './confimation-dialog.component.html',
    styleUrls: ['./confimation-dialog.component.scss']
})
export class ConfimationDialogComponent implements OnInit {

    constructor(
        protected dialogRef: MatDialogRef<ConfimationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public params: {
            title: string,
            message: string,
            cancelButtonTxt: string,
            acceptButtonTxt: string,
            acceptFunction: () => Promise<void>,
            cancelFuntion: () => Promise<void>
        },
    ) { }

    ngOnInit(): void {
    }


    public async accept(): Promise<void> {
        await this.params.acceptFunction();
        this.dialogRef.close();
    }

    public async cancel(): Promise<void> {
        await this.params.cancelFuntion();
        this.dialogRef.close();
    }
}
